import { MolsonBox, MolsonTypography } from '@common/reusable'
import type { BoxProps } from '@mui/material'
import { molsonUseTheme } from '@theme/customMuiExports'
import type { FC, ReactNode } from 'react'

export type MolsonCustomChipProps = BoxProps & {
  dataTestId?: string
  selected?: boolean
  onClick?: () => void
  children: ReactNode
}

export const MolsonCustomChip: FC<MolsonCustomChipProps> = ({
  dataTestId,
  selected = false,
  onClick,
  children,
  ...props
}) => {
  const theme = molsonUseTheme()

  return (
    <MolsonBox
      dataTestId={dataTestId}
      sx={{
        py: 1.25,
        px: 2,
        borderRadius: 2.5,
        border: selected
          ? `1px solid ${theme.palette.primary.main}`
          : `1px solid ${theme.palette.secondary[600]}`,
        boxShadow: selected
          ? `0px 0px 0px 4px ${theme.palette.primary.lightest}`
          : 'none',
        width: 'fit-content',
        cursor: 'pointer',
        height: 33,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none'
      }}
      onClick={onClick}
      {...props}
    >
      <MolsonTypography variant="h4" color={theme.palette.secondary[700]}>
        {children}
      </MolsonTypography>
    </MolsonBox>
  )
}
